/**
 * Centralized consent checkbox copy — one place for the attorney to edit.
 *
 * DR principle: the intake checkbox is a single, combined statement covering
 * terms + privacy + medical disclaimer. A fourth AI-processing checkbox is
 * intentionally NOT shown on the cold-traffic intake form — users consent to
 * the AI-sharing clause via the Privacy Policy, not a separate toggle.
 *
 * If/when the attorney signs off on exact wording, swap strings here and
 * bump the relevant version in versions.ts.
 */

export const SIGNUP_CHECKBOX_LABEL =
  'I agree to the Terms, Privacy Policy, and Medical Disclaimer. ' +
  'I understand this is not medical advice and that I should discuss ' +
  'results with my licensed healthcare provider.';

/** Inline link targets used inside the checkbox label. */
export const SIGNUP_CHECKBOX_LINKS = [
  { label: 'Terms', href: '/terms' },
  { label: 'Privacy Policy', href: '/privacy-policy' },
  { label: 'Medical Disclaimer', href: '/medical-disclaimer' },
] as const;

/** Shown on /consent/update when we re-prompt for a new version. */
export const UPDATE_PROMPT_HEADING = 'We updated a few documents.';
export const UPDATE_PROMPT_BODY =
  'Before you continue, please re-confirm that you agree to the current ' +
  'Terms, Privacy Policy, and Medical Disclaimer.';
export const UPDATE_PROMPT_CHECKBOX =
  'I agree to the updated Terms, Privacy Policy, and Medical Disclaimer.';
